<template>
  <v-btn
    v-bind="props"
    href="#"
    @click.prevent="
      $vuetify.goTo(item.link, {
        offset: $store.state.section.stickyHeader.height
      })
    "
    >{{ item.name }}</v-btn
  >
</template>

<script>
export default {
  name: 'SectionMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
